import {Code} from '@mantine/core';

Code.displayName = 'Code';

export {Code, type CodeFactory, type CodeProps} from '@mantine/core';
